import type { IconSvgObject } from './types';

const Heading05Icon: IconSvgObject = [
  ["path", { d: "M3 12H12M3 19V5M12 19V5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19.5 11H16V14H17.5C18.8807 14 20 15.1319 20 16.5126C20 17.8795 18.8668 19 17.5 19C16.5 19 16 18.5 16 18.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Heading05Icon;
